export enum WorkplaceType {
	MAIN = 'main',
	NORMAL = 'normal',
	FOLDER = 'folder',
}
